import React from "react";
import { reviewPlatforms as defaultPlatforms } from "../mock";
import { Star } from "lucide-react";
import { useI18n } from "../lib/i18n";
import { useSettings } from "../lib/settings";
import { T } from "../lib/autoTranslate";

const ReviewBar = () => {
  const { t } = useI18n();
  const { settings } = useSettings();
  const s = settings || {};
  const platforms = (s.review_platforms && s.review_platforms.length > 0) ? s.review_platforms : defaultPlatforms;
  const rating = s.overall_rating || "4.95";
  const note = s.overall_reviews_note || `${t("read_reviews")} →`;

  return (
    <section id="review-stats" className="bg-[#fffdf7] border-b border-[var(--ri-border)]">
      <div className="container-x py-8 grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
        <div>
          <div className="font-serif-display text-[42px] leading-none">{rating}</div>
          <div className="flex items-center gap-0.5 mt-2">
            {Array.from({ length: 5 }).map((_, i) => (
              <Star key={i} size={16} className="rating-star" fill="currentColor" />
            ))}
          </div>
        </div>

        <div className="max-w-[320px]">
          <p className="font-serif-italic text-[var(--ri-red)] text-[17px] leading-snug">
            <T>{note}</T>
          </p>
          <p className="text-[13px] text-[var(--ri-muted)] mt-1">
            across {platforms.map((p) => p.name).join(", ")}
          </p>
        </div>

        <ul
          className="grid gap-3"
          style={{ gridTemplateColumns: "repeat(auto-fit, minmax(72px, 1fr))" }}
        >
          {platforms.map((p, i) => (
            <li key={p.name + i} className="text-center">
              <div className="text-[12px] text-[var(--ri-muted)] font-medium">{p.name}</div>
              <div className="text-[15px] font-semibold mt-1">{p.rating}</div>
              <div className="text-[12px] text-[var(--ri-muted)]">· {p.count}</div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default ReviewBar;
